import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver';

import { WristbandsService } from '@app/shared/services/wristbands.service';

import { ApiService, AuthenticationService, ThemeService } from '@shared/services';

@Component({
    selector: 'app-show-contacts',
    templateUrl: './show-contacts.component.html',
    styleUrls: ['./show-contacts.component.scss'],
    standalone: false
})
export class ShowContactsComponent implements OnInit {
  userInfoId: any;
  myForm: FormGroup;
  name: string;
  email: string;
  surname: string;
  phone: string;
  comment: string;
  userId: string;
  eventId: string;
  accountId: string;
  users: any[];
  filename: string;
  blobUrl: string;
  userPass: {ScannedUserid: any};
  loading = true;
  modalMode = false;
  panelClass: any;
  headerText = (localStorage.getItem('lang') === 'es') ? 'Lista de Contactos' : 'Contact List';

  constructor(private apiService: ApiService,
              private formBuilder: FormBuilder,
              private auth_service: AuthenticationService,
              private wrist_service: WristbandsService,
              public themeService: ThemeService,
              public dialog: MatDialog,
  ) {
    this.accountId = JSON.parse(localStorage.getItem('accountId'));
    this.myForm = this.formBuilder.group({
      name: [this.name],
      surname: [this.surname],
      email: [this.email],
      phone: [this.phone],
      comment: [this.comment]
    });
    const currentDate = new Date();
    this.filename = `LeadScannerContacts_${currentDate.toISOString()}.csv`;
   }

  ngOnInit(): void {
    const event = JSON.parse(localStorage.getItem('eventSelected'));
    this.eventId = event.id;
    this.userId = this.auth_service.user.id;
    this.apiService.get(`events/${this.eventId}/users/${this.userId}/showScannedInfo`).subscribe({next: (data) => {
        this.users = data;
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  onDownloadCSV() {
    this.wrist_service.downloadFile(this.accountId, this.eventId, this.userId).subscribe((response: any) => {
      const blob: any = new Blob([response], { type: 'text/csv; charset=utf-8' });
      saveAs(blob, this.filename);
    }), error => console.error('Ha ocurrido un error descargando el archivo', error),
          () => console.info('Archivo descargado con exito');
   }
}
